module.exports = __webpack_public_path__ + "static/media/gandalf.74227836.png";